import { render } from "./S200347.vue?vue&type=template&id=d23d741e"
const script = {}
script.render = render

export default script